// extracted by mini-css-extract-plugin
module.exports = {"reviews__wrapper":"Z_bv","reviews__wrapper__list":"Z_d8","reviewSlider":"Z_d9"};